
export default {
  props: {
    page: {
      type: Object,
      required: true,
    },
  },

  computed: {
    hasImage() {
      return this.page?.image
    },

    authors() {
      if (Array.isArray(this.page?.authors) && this.page?.authors.length > 0) {
        return this.page.authors
      }

      return this.page?.authors_external
    },
  },
}
